// Temporarily disable camelcase to match LandingPage fields
/* eslint-disable camelcase */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  newButton: {
    fontFamily: 'Inter, sans-serif',
    padding: '5px 10px',
    outline: 'none',
    borderRadius: '4px',
    background: 'white',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    fontSize: '16px',
    marginHorizontal: 'auto',
    pointer: 'cursor',
    transition: 'all 250ms',
    '&:hover,\n  &:focus': { opacity: 0.8 },
  },
  pageBackground: {
    backgroundColor: 'white',
    minWidth: '300px',
    borderRadius: '4px',
    padding: '25px 30px 25px 30px',
    border: `1px solid ${theme.palette.colors.grey}`,
  },
  flexContainer: { display: 'flex', flexDirection: 'column', width: '100%' },
  pageElement: {
    border: '1px solid #e0e0e0',
    borderRadius: '12px',
    padding: '4px',
    width: '100%',
    margin: '5px 0 5px 0',
  },
  elementTitle: {
    fontStyle: 'italic',
    fontSize: '12px',
    color: '#aaaaaa',
    flex: 1,
    marginLeft: '1rem',
  },
  elementContent: {
    color: 'black',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: '12px',
  },
  bold: {
    fontWeight: 'bold',
    fontSize: '1.5rem',
  },
  textAreaRows: {
    width: '100%',
    height: '100%',
    padding: '0.5rem 1rem',
    border: 'none',
    borderBottom: '1px solid black',
    backgroundColor: 'inherit',
    color: 'inherit',
    position: 'relative',
    bottom: '0.625rem',
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.925rem',
    outline: 'none',
  },
  editsWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
}));

const ElementCard = ({
  type,
  headline,
  content,
  onFieldSelect,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.pageElement} id={type}>
      <div
        className="row "
        style={{ justifyContent: 'center', alignItems: 'center' }}
        onClick={(event) => event.stopPropagation()}
        id={type}
      >
        <div className={classes.elementTitle} id={type}>
          {type}
        </div>
      </div>
      {headline && (
        <div
          className={clsx(classes.elementContent, classes.bold)}
          id={type}
          onMouseMove={onFieldSelect(headline.name)}
        >
          {((type === 'Heading') && (
            <span id={type} style={{ fontSize: '1.5rem' }}>
              {headline.value}
            </span>
          )) || ((type === 'Subheading') && (
            <span id={type} style={{ fontSize: '1.2rem', color: 'grey' }}>
              {headline.value}
            </span>
          )) || (
            <span id={type} style={{ fontSize: '1.2rem' }}>
              {headline.value}
            </span>
          )}
        </div>
      )}
      {content && (
        <>
          {' '}
          <hr />
          <div
            className={classes.elementContent}
            id={type}
            onMouseMove={onFieldSelect(content.name)}
          >
            {type === 'Slogan' ? (
              <span id={type} style={{ fontSize: '1rem' }}>
                <i>{content.value}</i>
              </span>
            ) : (
              <span id={type}>{content.value}</span>
            )}
          </div>
          {' '}
        </>
      )}
    </div>
  );
};

/**
 * Render the landingpage -- similar to landing page atom
 *
 * @param {Object} props - props object
 * @param {Object} props.landingPageObject -
 */
const LandingPage = ({
  content,
  // onTextSelect = () => null,
}) => {
  const classes = useStyles();

  // const [
  //   selectedField,
  //   setSelectedField,
  // ] = React.useState(null);

  const onFieldSelect = () => {};

  // CURRENTLY UNSUPPORTED
  // const onFieldSelect = (field) => () => setSelectedField(field);
  // const onContentSelect = () => {
  //   const text = window.getSelection().toString().trim();

  //   if (!text || !content[selectedField].includes(text)) {
  //     onTextSelect(null);
  //     return;
  //   }

  //   onTextSelect({
  //     text,
  //     field: selectedField,
  //   });
  // };

  const {
    heading,
    subheading,
    benefit1,
    benefit1_description,
    benefit2,
    benefit2_description,
    benefit3,
    benefit3_description,
    slogan,
    // title,
  } = content;

  return (
    <div
      className={classes.pageBackground}
      // onMouseUp={onContentSelect}
    >
      <div className={classes.flexContainer}>
        <ElementCard
          type="Headline"
          headline={{
            name: 'heading',
            value: heading,
          }}
          onFieldSelect={onFieldSelect}
        />

        <ElementCard
          type="Subheadline"
          headline={{
            name: 'subheading',
            value: subheading,
          }}
          onFieldSelect={onFieldSelect}
        />

        <ElementCard
          type="Feature 1"
          headline={{
            name: 'benefit1',
            value: benefit1,
          }}
          content={{
            name: 'benefit1_description',
            value: benefit1_description,
          }}
          onFieldSelect={onFieldSelect}
        />

        <ElementCard
          type="Feature 2"
          headline={{
            name: 'benefit2',
            value: benefit2,
          }}
          content={{
            name: 'benefit2_description',
            value: benefit2_description,
          }}
          onFieldSelect={onFieldSelect}
        />

        <ElementCard
          type="Feature 3"
          headline={{
            name: 'benefit3',
            value: benefit3,
          }}
          content={{
            name: 'benefit3_description',
            value: benefit3_description,
          }}
          onFieldSelect={onFieldSelect}
        />

        <ElementCard
          type="Closing"
          headline={{
            name: 'slogan',
            value: slogan,
          }}
          onFieldSelect={onFieldSelect}
        />
      </div>
    </div>
  );
};

export default LandingPage;
